// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__Tz9Sp","anima_skeleton":"Skeleton_anima_skeleton__dv4LH"};